module.exports = __webpack_public_path__ + "img/rank3.d5486bb.png";